module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "avatar__bg",
    attrs: {
      "d": "M12 24A12 12 0 0 1 0 12 12 12 0 0 1 12 0a12 12 0 0 1 12 12 12 12 0 0 1-12 12z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#FFE1A4",
      "cx": "6.2",
      "cy": "12.1",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#FFE1A4",
      "cx": "17.8",
      "cy": "12.1",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFE1A4",
      "d": "M6.2 8.2H18v8.7H6.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#50360e",
      "d": "M18.5 16.3c0-.5-.2-.9-.5-1.2V9.9c-.8 0-1.5.7-1.5 1.5v2.4c0 .5-.3.7-.7.7H8.4c-.5 0-.7-.3-.7-.7v-2.4c0-.8-.7-1.5-1.5-1.5v4.9c-.5.3-.7.8-.7 1.3 0 .8.6 1.5 1.4 1.7v.1c0 1.2 1 2.2 2.2 2.2l.7-.1c.4.7 1.1 1.3 2 1.3a2 2 0 0 0 1.9-1.2c.3.2.7.3 1.1.3a2 2 0 0 0 2-2v-.3c.9 0 1.7-.8 1.7-1.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#14243a",
      "d": "M12 17.6c.7 0 1.2-.5 1.4-1.1.1-.2-.1-.5-.4-.5h-2.1c-.2 0-.5.2-.4.5.3.8.8 1.1 1.5 1.1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#FFE1A4",
      "cx": "12",
      "cy": "14",
      "r": "1.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#14243a",
      "cx": "9.9",
      "cy": "12.6",
      "r": ".6"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#14243a",
      "cx": "14.1",
      "cy": "12.6",
      "r": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F44542",
      "d": "M17.5 9h-11v-.8c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5V9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#db3f3b",
      "d": "M17.9 9H6.1a.9.9 0 0 1-.8-.8c0-.5.4-.8.8-.8h11.6c.5 0 .8.4.8.8.1.5-.2.8-.6.8z"
    }
  })])]), _vm._v(" "), _c('h1', [_vm._v("About me")]), _vm._v(" "), _c('p', [_vm._v("\n      I'm a developer living in Flensburg, Germany. The purpose of this website is to present my projects and some thoughts. Here is a short curriculum vitae: ")]), _vm._v(" "), _c('p', [_vm._v("\n      I was born in Flensburg, Germany, in 1983."), _c('br'), _vm._v(" After school I studied philosophy, psychology and German literature in Kiel, while working in IT-related jobs. After graduating as a\n      "), _c('i', {
    attrs: {
      "title": "That was the german equivalent to the Master of Arts degree, back then."
    }
  }, [_vm._v("Magister Artium")]), _vm._v(" with a thesis about\n      "), _c('i', {
    attrs: {
      "title": "To talk in the first person a lot"
    }
  }, [_vm._v("Egotism")]), _vm._v(", I was working as a teacher, biographer and lector. Then I decided I wanted to start learning something new again, so I returned to my old passion, the IT. I became a developer, focussing on frontend technologies. I love learning new things, so to this day I am very happy with my decision to make my living within a field in which new ideas and concepts emerge all the time. If you would like to see if I am suited for your project, please head over to the "), _c('router-link', {
    attrs: {
      "to": "/developer"
    }
  }, [_vm._v("developer section")]), _vm._v(".\n    ")], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      You are welcome to get a more detailed look at my career on my\n      "), _c('a', {
    attrs: {
      "href": "https://www.xing.com/profile/Merten_Hanisch",
      "target": "_blank"
    }
  }, [_vm._v("Xing profile")]), _vm._v("! ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('h2', [_vm._v("Other than that...")]), _vm._v(" "), _c('p', [_vm._v("\n      ... who doesn't like to do something different from time to time? Like ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://mortal.host",
      "target": "_blank"
    }
  }, [_vm._v("Developing games")])]), _vm._v(" "), _c('li', [_vm._v("Getting away from technology and living in a\n        "), _c('a', {
    attrs: {
      "href": "http://valsgaard.de/"
    }
  }, [_vm._v("viking village")]), _vm._v(" every now and then\n      ")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCqJToZ8hMUVA6Hrgl_jqfKA",
      "target": "_blank"
    }
  }, [_vm._v("Playing the\n          concertina in dashing costumes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fab373a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/about.vue
// module id = 86
// module chunks = 1